import { render, staticRenderFns } from "./AutomaticReportsList.vue?vue&type=template&id=8b320d36&"
import script from "./AutomaticReportsList.vue?vue&type=script&lang=ts&"
export * from "./AutomaticReportsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports